import React, { useState } from 'react'
import { Form, Input, Button, Checkbox, message } from 'antd'
import { useDispatch } from 'react-redux'
import { adminLoginThunk } from '../../redux/features/admin/adminThunk'
import { useNavigate } from 'react-router-dom'
import LogoSVG from '../../assets/LogoSVG'
import { clearError } from '../../redux/features/admin/adminSlice'
import './LoginPage.css'

const LoginPage = () => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const onFinish = (values: any) => {
    const { email, password } = values
    const trimmedEmail = email.trim().toLowerCase()
    setLoading(true)
    dispatch(clearError())
    dispatch(adminLoginThunk({ email: trimmedEmail, password }))
      .unwrap()
      .then(() => {
        message.success('Login successful! Redirecting...')
        setTimeout(() => {
          navigate('/')
        }, 500)
      })
      .catch((err: any) => {
        message.error(err || 'Login failed. Please check your credentials.')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const onFinishFailed = (errorInfo: any) => {
    console.error('Failed:', errorInfo)
    message.error('Submission failed, please check your input.')
  }

  return (
    <div className="login-form-container">
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        className="login-form"
      >
        <Form.Item className="form-item-logo">
          <LogoSVG height={90} width={90} />
        </Form.Item>
        
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' }
          ]}
        >
          <Input 
            placeholder="Email" 
            type="email"
          />
        </Form.Item>
        
        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password placeholder="Password" />
        </Form.Item>
        
        <Form.Item>
          <Checkbox>Remember me</Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Log in
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default LoginPage
